/* eslint-disable no-unused-vars */
import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";

function valuetext(value) {
  return `${value}`;
}

const sliderRoot = {
  touchAction: "auto",
};

export default function RangeSetting(props) {
  const { name, setting, handleSettingModified } = props;
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener(
        "touchstart",
        (e) => {
          const isThumb = e.target?.dataset.index;
          if (!isThumb) {
            e.stopPropagation();
          }
        },
        { capture: true }
      );
    }
  });
  return (
    <>
      <Typography
        gutterBottom
      >{`${name}: ${setting.Value} (${setting.Min} - ${setting.Max})`}</Typography>
      <Slider
        ref={ref}
        sx={sliderRoot}
        value={Number(setting.Value)}
        getAriaValueText={valuetext}
        step={1}
        min={Number(setting.Min)}
        max={Number(setting.Max)}
        valueLabelDisplay='auto'
        disabled={setting.Max === setting.Min}
        onChange={(event) => {
          handleSettingModified(name, event.target.value);
        }}
      />
    </>
  );
}

RangeSetting.propTypes = {
  name: PropTypes.string.isRequired,
  setting: PropTypes.shape({
    Min: PropTypes.string.isRequired,
    Max: PropTypes.string.isRequired,
    Value: PropTypes.string.isRequired,
  }).isRequired,
  handleSettingModified: PropTypes.func.isRequired,
};
